/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/redo_medium'
export default icon
